import React, { forwardRef } from "react";
const DeviceAudio = forwardRef((props: { id?: string }, ref: (ref: any) => void) => <audio id={props.id} ref={ref} />);

DeviceAudio.displayName = "DeviceAudio";

export default DeviceAudio;
